<template>
    <v-dialog
        v-if="splitedTasksDialog"
        v-model="splitedTasksDialog"
        persistent
        width="600px"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon dark class="mr-2">call_split</v-icon>Splited Tasks
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('closeSplittedDialog')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pb-0 px-0">
                <!-- old growth task -->
                <GrowthTaskQrCode
                    :task="splittedGrowthTask.currentGrowthTask"
                    :printId="
                        splittedGrowthTask.currentGrowthTask
                            ? splittedGrowthTask.currentGrowthTask.id
                            : 'printMe'
                    "
                ></GrowthTaskQrCode>

                <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        outlined
                        class="primary--text"
                        min-width="120px"
                        v-print="
                            '#' +
                                (splittedGrowthTask.currentGrowthTask
                                    ? splittedGrowthTask.currentGrowthTask
                                            .id
                                    : 'printMe')
                        "
                        >Print</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>

                <hr />

                <!-- new growth task -->
                <GrowthTaskQrCode
                    :task="splittedGrowthTask.newGrowthTask"
                    :printId="
                        splittedGrowthTask.newGrowthTask
                            ? splittedGrowthTask.newGrowthTask.id
                            : 'printMe'
                    "
                ></GrowthTaskQrCode>
                <v-card-actions class="pb-5">
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        outlined
                        class="primary--text"
                        min-width="120px"
                        v-print="
                            '#' +
                                (splittedGrowthTask.newGrowthTask
                                    ? splittedGrowthTask.newGrowthTask.id
                                    : 'printMe')
                        "
                        >Print</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import GrowthTaskQrCode from "@/components/growth/GrowthTaskQrCode.vue";

export default {
    name : "QRCodeSplitedTasks",
    props : ["splitedTasksDialog","splittedGrowthTask","",""],
    components : {
        GrowthTaskQrCode
    }
}
</script>